import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import '../Button/index.js';
import '../TextLink/index.js';
import { TextLink } from '../TextLink/TextLink.js';
import { Button as ButtonMemoized } from '../Button/Button.js';

var Actions = function Actions(_ref) {
  var actions = _ref.actions,
    actionDirection = _ref.actionDirection;
  var marginProps = actionDirection === 'column' ? {
    mb: '8',
    ms: '0'
  } : {
    ms: '8'
  };
  var getActionElement = function getActionElement(action) {
    if (!action) return null;
    if (action.actionType === 'textLink') {
      return /*#__PURE__*/React.createElement(Box, _extends({
        textAlign: "center",
        p: "8",
        key: action.label
      }, marginProps), /*#__PURE__*/React.createElement(TextLink, _extends({
        textVariant: "body-default"
      }, action)));
    }
    return /*#__PURE__*/React.createElement(ButtonMemoized, _extends({
      size: "l",
      key: action.label
    }, marginProps, action));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, actions === null || actions === void 0 ? void 0 : actions.map(function (action) {
    return getActionElement(action);
  }));
};
Actions.displayName = 'Actions';

export { Actions };
//# sourceMappingURL=Actions.js.map
